<template>
  <div>
      <v-layout wrap row justify-start pa-2 py-5>
        <v-flex xs12 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Migrate Leads to new DB
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
								<v-flex xs12 md12 pa-1>
									<v-textarea
										label="Keys & Document Numbers"
										v-model="spastedData"
										solo
									></v-textarea>
              	</v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  {{[...mleads, ...nleads, ...fleads, ...sleads].length}} / {{oleads.length}}
                </v-flex>
                <v-flex xs12>
									<v-layout row wrap>
                    <v-flex xs3>
                      <div style="font-weight:bold;">Not Found</div>
                      <v-layout row wrap>
                        <v-flex xs12 pa-2 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                          <div v-for="k in nleads" :key="k+ '-Not Found'">{{k}}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs3>
                      <div style="font-weight:bold;">Already Moved</div>
                      <v-layout row wrap>
                        <v-flex xs12 pa-2 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                          <div v-for="k in mleads" :key="k+ '-Migrated'">{{k}}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs3>
                      <div style="font-weight:bold;">Failed</div>
                      <v-layout row wrap>
                        <v-flex xs12 pa-2 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                          <div v-for="k in fleads" :key="k+ '-Failed'"
                            v-clipboard:copy="k"
                            v-clipboard:success="clipboardSuccessHandler"
                            v-clipboard:error="clipboardErrorHandler"
                          >{{k}}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs3>
                      <div style="font-weight:bold;">Migrated</div>
                      <v-layout row wrap>
                        <v-flex xs12 pa-2 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                          <div v-for="k in sleads" :key="k+ '-Error'"
                            v-clipboard:copy="k"
                            v-clipboard:success="clipboardSuccessHandler"
                            v-clipboard:error="clipboardErrorHandler"
                          >{{k}}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
								</v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
							<!-- <v-btn @click="updateByKey()" :loading="loading" color="success" dark>
                update keys with values
              </v-btn> -->
              <v-btn color="primary" @click="migrate()">migrate</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import axios from 'axios';
export default {
  data(){
    return {
			loading: false,
      pastedData:null,
      spastedData:null,
			delimiter:',',
      oleads:[],
      mleads:[],
      nleads:[],
      fleads:[],
      sleads:[],
    }
  },
  methods: {
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
		guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
		getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
      var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			console.log(result);
			return result
    },
    async migrate(){
      this.oleads = []
      this.mleads = []
      this.nleads = []
      this.fleads = []
      this.sleads = []
			let a = this.spastedData.split('\n').filter(x=> x && x.trim() != '').map(x=>{
        return {
          key: x.trim()
        } 
      });
      this.oleads = a;
      (async () => {
				for (let i = 0; i < a.length; i++) {
          let key = a[i].key
          let o = await db.ref(`leads/${key}`).once('value').then(x=>x.val()) 
          if(o) {
            try {
              await store.collection('leads').doc(key).update(o)
            } catch (error) {
              await store.collection('leads').doc(key).set(o)
            }
            let c = await store.collection('leads').doc(key).get().then(x=>x.data())
            if(c) {
              await db.ref(`leads`).update({[key]:null})
              this.sleads.push(key)
            } else {
              this.fleads.push(key)
            }
          } else {
            let oS = await store.collection('leads').doc(key).get().then(x=>x.data())
            if(oS) {
              this.mleads.push(key)
            } else {
              this.nleads.push(key)
            }
          }
        }
        this.$emit('snackbarNotification', `Done`, 'success')
			})()
      
    },
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
		}
  },
  computed:{
    
  },
  async created(){

  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
